import Actions from './action';
export const initState = {
	appLoader: true,
	userDetails: null,
};

const appReducer = (state = initState, action) => {
	switch (action.type) {
		case Actions.types.SET_USER: {
			return {
				...state,
				appLoader: false,
				userDetails: {
					...action.userDetails,
				},
			};
		}
		case Actions.types.NO_USER: {
			return {
				...state,
				appLoader: false,
			};
		}
		case Actions.types.REMOVE_USER: {
			return {
				...state,
				// userDetails: null,
			};
		}
		case Actions.types.RESET_VALUES: {
			return {
				...state,
				userDetails: null,
			};
		}

		default:
			return state;
	}
};

export default appReducer;
